import React, { useState, useEffect } from 'react';
import { NativeBiometric } from 'capacitor-native-biometric';
import { NativeSettings, AndroidSettings, IOSSettings } from 'capacitor-native-settings';
import { IonToggle, IonItem, IonAlert } from '@ionic/react';

import '../../styles/authentication/FaceIDToggle.scss';

function FaceIDToggle({ value, setter, disabled }) {
  const [showSettingsAlert, setShowSettingsAlert] = useState(false);

  useEffect(() => {
    const checkAvailable = async () => {
      const result = await NativeBiometric.isAvailable();
      if (!result.isAvailable) {
        console.warn('Biometric authentication is not available.');
        setter(false);
        setShowSettingsAlert(true);
      }
    };
    if (value) {
      checkAvailable();
    }
  }, [value, setter]);

  return (
    <div>
      <IonItem className='face-id-toggle' lines='none' disabled={disabled}>
        <span className='label'>Face ID</span>
        <IonToggle
          className='button'
          checked={value}
          disabled={disabled}
          onIonChange={e => {
            setter(e.detail.checked);
          }}
        />
      </IonItem>
      <IonAlert
        isOpen={showSettingsAlert}
        header='Enable Face ID'
        message='You must enable Face ID to autofill username and password from face scan'
        buttons={[
          'Not Now',
          {
            text: 'Go to Settings',
            handler: () => {
              NativeSettings.open({
                optionAndroid: AndroidSettings.ApplicationDetails,
                optionIOS: IOSSettings.App,
              });
            },
          },
        ]}
        onDidDismiss={() => setShowSettingsAlert(false)}
      />
    </div>
  );
}

export default FaceIDToggle;
